import { useParams } from 'react-router-dom'

import { TrainingRequestDetailFragment } from 'generated/resources/graphql'

import { useFormContext } from 'modules/core/hooks/useForm'

import { useManagedIds } from 'modules/trainings/components/Shared/WizardComponent/EmployeeSelectorStep/useManageIds'
import { RequestType, UpdateData } from 'modules/trainings/pages/MyTrainings/RequestDetail/types'

import { FromCatalogComponent } from './FromCatalogComponent'
import { NewProposalComponent } from './NewProposalComponent'

interface Props {
  trainingRequest: TrainingRequestDetailFragment
  back: string
  selectedRequestType: RequestType
  setSelectedRequestType: (value: RequestType) => void
  isApprover?: boolean
  manageEveryone: boolean
  manageEmployee: boolean
}

export const RequestDetailComponent = ({
  trainingRequest,
  selectedRequestType,
  setSelectedRequestType,
  isApprover,
  manageEveryone,
  manageEmployee,
}: Props) => {
  const { id } = useParams()

  const { excludedEmployeeIds, managedEmployeeIds } = useManagedIds(manageEveryone)
  const disableForm = trainingRequest.status !== 'draft' && !isApprover
  const readonly =
    trainingRequest.status == 'approved' ||
    trainingRequest.status == 'rejected' ||
    !manageEmployee ||
    disableForm
  const form = useFormContext<UpdateData>()
  const onChangeTrainingType = (value: RequestType) => {
    if (value === 'newRequest') {
      form.setValues({ ...form.values, trainingId: undefined })
    }
    setSelectedRequestType(value)
  }

  return selectedRequestType === 'newRequest' ? (
    <NewProposalComponent
      onChangeTrainingType={onChangeTrainingType}
      id={id}
      form={form}
      selectedRequestType={selectedRequestType}
      trainingRequest={trainingRequest}
      readonly={readonly}
      excludedEmployeeIds={excludedEmployeeIds}
      managedEmployeeIds={managedEmployeeIds}
    />
  ) : (
    <FromCatalogComponent
      onChangeTrainingType={onChangeTrainingType}
      id={id}
      readonly={readonly}
      excludedEmployeeIds={excludedEmployeeIds}
      managedEmployeeIds={managedEmployeeIds}
      form={form}
      selectedRequestType={selectedRequestType}
      trainingRequest={trainingRequest}
    />
  )
}
